import {
  GET_AD_GROUP_AD,
  GET_AD_GROUP_AD_SUCCESS,
  GET_AD_GROUP_AD_ERROR,
  CREATE_AD_GROUP_AD,
  CREATE_AD_GROUP_AD_SUCCESS,
  CREATE_AD_GROUP_AD_ERROR,
  UPDATE_AD_GROUP_AD,
  UPDATE_AD_GROUP_AD_SUCCESS,
  UPDATE_AD_GROUP_AD_ERROR,
  DELETE_AD_GROUP_AD_SUCCESS,
  DELETE_AD_GROUP_AD_ERROR,
  DELETE_AD_GROUP_AD,
} from "./actionTypes"

const initialState = {
  ad_group_ads: [],
  error: null,
  loading: false,
  ad_group_ads_fetched: false,
  get_ad_group_ads_loading: false
}

const AdGroupAd = (state = initialState, action) => {
  switch (action.type) {
    case GET_AD_GROUP_AD:
      return {
        ...state,
        loading: true,
        get_ad_group_ads_loading: true
      }

    case GET_AD_GROUP_AD_SUCCESS:
      return {
        ...state,
        ad_group_ads: action.payload,
        loading: false,
        ad_group_ads_fetched: true,
        get_ad_group_ads_loading: false
      }

    case GET_AD_GROUP_AD_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        get_ad_group_ads_loading: false
      }

    case CREATE_AD_GROUP_AD:
      return {
        ...state,
        loading: true
      }

    case CREATE_AD_GROUP_AD_SUCCESS:
      return {
        ...state,
        ad_group_ads: [...state.ad_group_ads, ...action.payload],
        loading: false
      }

    case CREATE_AD_GROUP_AD_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case UPDATE_AD_GROUP_AD:
      return {
        ...state,
        loading: true
      }

    case UPDATE_AD_GROUP_AD_SUCCESS:
      return {
        ...state,
        ad_group_ads: state.ad_group_ads.map(ad_group_ad => (ad_group_ad.id === action.payload.id) ? action.payload : ad_group_ad),
        loading: false
      }

    case UPDATE_AD_GROUP_AD_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case DELETE_AD_GROUP_AD:
      return {
        ...state,
        loading: true
      }

    case DELETE_AD_GROUP_AD_SUCCESS:
      return {
        ...state,
        ad_group_ads: state.ad_group_ads.filter(ad_group_ad => (ad_group_ad.id !== action.payload.id)),
        loading: false
      }

    case DELETE_AD_GROUP_AD_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    default:
      return state
  }
}

export default AdGroupAd
